import moment from "moment";
import { useState } from "react";
import {
  getAllDirectors,
  getAllMembers,
  getAllMembersByCommitteeId,
  getAllModality,
  getAllThemes,
  getMembersById,
  getMembersByName
} from "../services/formCombos.service.js";
import {
  BUDGETED_OPTIONS,
  CURRENCIES,
  DAYS,
  DAYSTOMEETFORM,
  ENDAFTER,
  FREQUENCY,
  FREQUENCYMEETING,
  MONTHS,
  ORDINAL_NUMBERS,
  STATUS,
  STATUS_COMMITTEE,
  STATUS_MATERIAL,
  STATUS_SLOT,
  TYPE_SLOT
} from "../utils/StaticLists";

const INITIAL_SUCCESS_ERROR = {
  getAllMembers: "",
  getAllThemes: "",
  getAllModality: "",
};

export const useFormCombos = () => {
  const [membersList, setMembersList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [modalityList, setModalityList] = useState([]);
  const [membersParticipantsList, setMembersParticipantsList] = useState([]);
  const [themesList, setThemesList] = useState([]);
  const [months, setMonths] = useState([]);

  const [currencies, setCurrencies] = useState([]);
  const [statusSlot, setStatusSlot] = useState([]);
  const [status, setStatus] = useState([]);
  const [statusCommittee, setStatusCommittee] = useState([]);
  const [statusMaterial, setStatusMaterial] = useState([]);

  const [years, setYears] = useState([]);
  const [frequency, setFrequency] = useState([]);
  const [frequencyMeeting, setFrequencyMeeting] = useState([]);
  const [ordinalNumber, setOrdinalNumber] = useState([]);

  const [endAfter, setEndAfter] = useState([]);
  const [days, setDays] = useState([]);
  const [typeSlot, setTypeSlot] = useState([]);
  const [budgetedOptions, setBudgetedOptions] = useState([]);
  const [directorsList, setDirectors] = useState([]);
  const [success, setSuccess] = useState(INITIAL_SUCCESS_ERROR);
  const [error, setError] = useState(INITIAL_SUCCESS_ERROR);
  const [meetingInfo, setMeetingInfo] = useState([]);

  const getMembers = async (languageId) => {
    clearAlerts();
    const response = await getAllMembers(languageId);
    if (response.error) {
      setMembersList([]);
      setError({ getAllMembers: response.error });
    } else {
      setMembersList(response.data);
    }
  };

  const getDirectors = async (languageId) => {
    clearAlerts();
    const response = await getAllDirectors(languageId);
    if (response.error) {
      setDirectors([]);
      setError({ getAllDirectors: response.error });
    } else {
      setDirectors(response.data);
    }
  };

  const getMembersByPartialName = async (languageId, name) => {
    clearAlerts();
    const response = await getMembersByName(languageId, name);
    if (response.error) {
      setFilteredList([]);
      setError({ getMembersByName: response.error });
    } else {
      setFilteredList(response.data);
    }
  };

  const getMembersByMemberId = async (languageId, id) => {
    clearAlerts();
    const response = await getMembersById(languageId, id);
    if (response.error) {
      setError({ getMembersById: response.error });
    } else {
      return response.data;
    }
  };

  const getMembersByCommitteeId = async (languageId, committeeId) => {
    clearAlerts();
    const response = await getAllMembersByCommitteeId(languageId, committeeId);
    if (response.error) {
      setMembersParticipantsList(response.data);
      setError({ getAllMembersByCommitteeId: response.error });
    } else {
      setMembersParticipantsList(response.data);
    }
  };

  const getAllModalityByLanguageId = async (languageId, listInactive) => {
    clearAlerts();
    const response = await getAllModality(languageId, listInactive);
    if (response.error) {
      setModalityList([]);
      setError({ getAllModality: response.error });
    } else {
      setModalityList(response.data);
    }
  };

  const getAllThemesByLanguageId = async (languageId) => {
    clearAlerts();
    const response = await getAllThemes(languageId);
    if (response.error) {
      setThemesList([]);
      setError({ getAllThemes: response.error });
    } else {
      setThemesList(response.data);
    }
  };

  const clearAlerts = () => {
    setSuccess(INITIAL_SUCCESS_ERROR);
    setError(INITIAL_SUCCESS_ERROR);
  };

  const sanitizeForTable = (list, ignore = []) => {
    return list.map((item) => {
      const dataTable = {
        id: item.id,
        name: item.name,
      };
      if (ignore.length > 0) {
        ignore.map((key) => {
          if (Object.keys(dataTable).includes(key)) delete dataTable[key];
        });
      }
      return dataTable;
    });
  };

  const sanitizeThemeForSelect = (list, ignore = []) => {
    return list.map((item) => {
      const dataTable = {
        id: item.id,
        name: item.themeName,
      };
      if (ignore.length > 0) {
        ignore.map((key) => {
          if (Object.keys(dataTable).includes(key)) delete dataTable[key];
        });
      }
      return dataTable;
    });
  };

  const sanitizeDirectorsForSelect = (list, ignore = []) => {
    return list.map((item) => {
      const dataTable = {
        id: item.id,
        name: item.directorName,
      };
      if (ignore.length > 0) {
        ignore.map((key) => {
          if (Object.keys(dataTable).includes(key)) delete dataTable[key];
        });
      }
      return dataTable;
    });
  };

  const getMonths = async (language) => {
    const response = MONTHS[language];
    setMonths(response);
  };

  const getCurrencies = async (language) => {
    const response = CURRENCIES[language];
    setCurrencies(response);
  };

  const getDays = async (language) => {
    const response = DAYS[language];
    setDays(response);
  };

  const getDaysFormMeetForm = async (language) => {
    const response = DAYSTOMEETFORM[language];
    setDays(response);
  };

  const getFrequency = async (language) => {
    const response = FREQUENCY[language];
    setFrequency(response);
  };

  const getFrequencyMeeting = async (language) => {
    const response = FREQUENCYMEETING[language];
    setFrequencyMeeting(response);
  };

  const getOrdinalNumber = async (language) => {
    const response = ORDINAL_NUMBERS[language];
    setOrdinalNumber(response);
  };

  const getEndAfter = async (language) => {
    const response = ENDAFTER[language];
    setEndAfter(response);
  };


  const getStatus = async (language) => {
    const response = STATUS[language];
    setStatus(response);
  };

  const getStatusCommittee = async (language) => {
    const response = STATUS_COMMITTEE[language];
    setStatusCommittee(response);
  };

  const getStatusSlot = async (language) => {
    const response = STATUS_SLOT[language];
    setStatusSlot(response);
  };

  const getStatusMaterial = async (language) => {
    const response = STATUS_MATERIAL[language];
    setStatusMaterial(response);
  };


  const getBudgetedOptions = async (language) => {
    const response = BUDGETED_OPTIONS[language];
    setBudgetedOptions(response);
  };

  const getTypeSlot = async (language) => {
    const response = TYPE_SLOT[language];
    setTypeSlot(response);
  };

  const getNextYears = async (yearCount) => {
    const currentYear = parseInt(moment().format("YYYY"), 10);
    const yearList = [];
    yearList.push({ id: currentYear, name: currentYear.toString() });
    for (let i = 1; i < yearCount; i++) {
      const nextYear = currentYear + i;
      yearList.push({ id: nextYear, name: nextYear.toString() });
    }
    setYears(yearList);
  };

  const getMeetingInfo = async (culture, meetingId) => {
    clearAlerts();
    const response = await getMeetingInfo(culture, meetingId);
    if (response.error) {
      setMeetingInfo([]);
      setMeetingInfo({ getAllModality: response.error });
    } else {
      setMeetingInfo(response.data);
    }
  };

  return {
    getMeetingInfo,
    getStatusSlot,
    getStatusMaterial,
    getTypeSlot,
    budgetedOptions,
    getBudgetedOptions,
    getAllModalityByLanguageId,
    getAllThemesByLanguageId,
    currencies,
    getCurrencies,
    getNextYears,
    getFrequency,
    getFrequencyMeeting,
    getMembers,
    getDirectors,
    getMembersByPartialName,
    getDaysFormMeetForm,
    getMembersByMemberId,
    sanitizeForTable,
    setMembersList,
    getMonths,
    getDays,
    getEndAfter,
    getStatus,
    getStatusCommittee,
    getOrdinalNumber,
    sanitizeThemeForSelect,
    sanitizeDirectorsForSelect,
    getMembersByCommitteeId,
    membersParticipantsList,
    endAfter,
    days,
    themesList,
    modalityList,
    status,
    statusCommittee,
    frequency,
    frequencyMeeting,
    years,
    months,
    typeSlot,
    membersList,
    directorsList,
    filteredList,
    success,
    error,
    ordinalNumber,
    statusSlot,
    statusMaterial,
    meetingInfo
  };
};
